let allowed = true;

export const waveformAllowed = () => allowed;

export const blockWaveform = () => {
  allowed = false;
};
